import { useUser } from "@/zustand/store";

const TermsAndConditions = () => {
  const { user } = useUser();
  return (
    <div>
      <div className="text-white">
        <h3 className="font-semibold">Terms & Conditions</h3>
        <h4 className="mt-6 text-xs font-semibold lg:mt-4">
          All Supported Usage Scenarios
        </h4>

        <p className="mt-2 text-xs leading-5 font-light">
          The card does not currently support Uber, Shell, and Iberia
          transactions.
        </p>
        <h4 className="mt-4 text-xs font-semibold">Card information </h4>
        <ol className="list-decimal pl-8 text-xs leading-4 *:font-light">
          <li>Card Issuer: Visa</li>
          <li>Card Type: Credit</li>
          <li>Card Form: Virtual</li>
          <li>Currency: USD</li>
          <li>Apple Pay supported: Yes</li>
          <li>Google Wallet supported: Yes</li>
        </ol>
        <h4 className="mt-4 text-xs font-semibold">Fees</h4>
        <p className="text-xs leading-5 font-light">
          Deposit Fee: {user.depositFee} USD
        </p>
        <p className="text-xs leading-5 font-light">
          Card Purchase Fee: {user.cardCreationFee} USD
        </p>
        <p className="text-xs leading-5 font-light">
          FX Fee: This can vary and only applies if a crossborder transaction or
          the billing currency is different from the settlement currency.
        </p>

        <h4 className="mt-4 text-xs font-semibold">Credit Limits</h4>
        <ol className="list-decimal pl-8 text-xs leading-4 font-light">
          <li>Maximum Deposit: $100,000 USD</li>
          <li>Maximum Card Purchase Quantity: 10</li>
          <li>Initial Deposit Required: Yes</li>
        </ol>
        <h4 className="mt-4 text-xs font-semibold">Card Usage Notice</h4>
        <ol className="list-decimal pl-8 text-xs leading-4 font-light">
          <li>
            If the card issuer detects malicious activities, such as bulk
            refunds, cancellations, failures or chargebacks during card usage,
            the card will be automatically frozen, and a fee of $50 USD per
            occurrence will be deducted.
          </li>
          <li>
            If the overall transaction failure rate exceeds 20%, the card will
            be automatically frozen.
          </li>
          <li>
            If the card has insufficient balance and accumulates up to 3
            consecutive authorization failures, the card will be automatically
            cancelled.
          </li>
          <li>
            If the card is frozen, please contact customer service to apply for
            unfreezing.
          </li>
          <li>The card is valid for 1 years.</li>
        </ol>
        <p className="mt-4 text-xs leading-5 font-light">
          <span className="font-medium">Card Currency:</span> Card currency
          refers to the currency type or unit associated with infinity cards. it
          plays a crucial role in determining the currency used for payment and
          settlement when utilising Zypher cards. It is highly recommended to
          utilise cards that align with the currency of the purchase order to
          mitigate the potential incurring of FX fees.
        </p>
        <p className="mt-2 text-xs leading-5 font-light">
          For customers with monthly transaction volumes exceeding 500,000 USD,
          please contact the support team for fee adjustments.
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
